import { render, staticRenderFns } from "./Swiper.vue?vue&type=template&id=2fc99f23&scoped=true&"
import script from "./Swiper.vue?vue&type=script&lang=js&"
export * from "./Swiper.vue?vue&type=script&lang=js&"
import style0 from "./Swiper.vue?vue&type=style&index=0&id=2fc99f23&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fc99f23",
  null
  
)

export default component.exports